module.exports = __webpack_public_path__ + "static/media/pic2.8004a069.jpg";